import { ChangeDetectorRef, Component, Host, HostBinding, Input, OnDestroy, OnInit,HostListener,ElementRef, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuService } from './app.menu.service';
import { LayoutService } from './service/app.layout.service';
import { EuMrvComponent } from '../pages/ems/eu-mrv/eu-mrv.component';
import { MenuSelectionService } from './service/menu-selection.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[app-menuitem]',
    template: `
        <ng-container>
            <!--<div *ngIf="root && item.visible !== false" class="layout-menuitem-root-text" >{{item.label}} </div>-->
            <a *ngIf="(!item.routerLink || item.items) && item.visible !== false" [attr.href]="item.url" (click)="itemClick($event)"
               [ngClass]="item.class" [attr.target]="item.target" tabindex="0" pRipple>
                <i [ngClass]="item.icon" class="layout-menuitem-icon" pTooltip="{{item.label}}" tooltipPosition="right"></i>
                <span class="layout-menuitem-text">{{item.label}}</span>
                <i class="menu-down layout-submenu-toggler" *ngIf="item.items"></i>
            </a>
            <a *ngIf="(item.routerLink && !item.items) && item.visible !== false" (click)="itemClick($event)" [ngClass]="item.class"
               [routerLink]="item.routerLink" routerLinkActive="active-route" [routerLinkActiveOptions]="item.routerLinkActiveOptions || defaultRouterLinkActiveOptions"
               [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling" [preserveFragment]="item.preserveFragment"
               [skipLocationChange]="item.skipLocationChange" [replaceUrl]="item.replaceUrl" [state]="item.state" [queryParams]="item.queryParams"
               [attr.target]="item.target" tabindex="0" pRipple>
                <i [ngClass]="item.icon" class="layout-menuitem-icon" pTooltip="{{item.label}}" tooltipPosition="right"></i>
                <span class="layout-menuitem-text" >{{item.label}}</span>
                <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
            </a>

            <ul *ngIf="item.items && item.visible !== false" [@children]="submenuAnimation">
                <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
                    <li app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child.badgeClass" class="p-menuitem"></li>
                </ng-template>
            </ul>
        </ng-container>
    `,
    animations: [
        trigger('children', [
            state('collapsed', style({
                
                height: '0'
            })),
            state('expanded', style({
                height: '*',
                
            })),
            transition('collapsed <=> expanded', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppMenuitemComponent implements OnInit, OnDestroy {
    /**
     * Shared, frozen default for [routerLinkActiveOptions].
     *
     * This used to be an inline object literal in the template
     * (`item.routerLinkActiveOptions || { paths: 'exact', ... }`). Angular
     * re-evaluates template expressions on every change-detection pass, so
     * that literal was a NEW object each pass for every menu item whose own
     * options are undefined — i.e. nearly all of them. RouterLinkActive then
     * saw a changed @Input, ran ngOnChanges -> update() -> markForCheck(),
     * which schedules another pass, which builds another literal: an
     * unbounded change-detection loop across the whole menu.
     *
     * Dev/UAT builds surface that as ExpressionChangedAfterItHasBeenChecked
     * and stop; production calls enableProdMode(), which removes that check,
     * so it simply spins — pinning the main thread on whichever page has the
     * most expensive change-detection pass.
     *
     * A single stable instance makes the binding reference-equal every pass.
     */
    readonly defaultRouterLinkActiveOptions = Object.freeze({
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored'
    }) as any;

    childItems: any=[];
    childCopy: any=[];
    @HostListener('document:click', ['$event'])
    clickout(event:any) {
      if(this.eRef.nativeElement.contains(event.target)) {
        if(event.target.textContent){
            if(this.menuService.childItems.includes(event.target.textContent)){
            this.active=false
        }

        }
      } else {
        this.active = false
      }
    }

    @Input() item: any;

    @Input() index!: number;

    @Input() @HostBinding('class.layout-root-menuitem') root!: boolean;

    @Input() parentKey!: string;
 
    active = false;

    menuSourceSubscription: Subscription;

    menuResetSubscription: Subscription;

    key: string = "";
    @Output() itemSelected = new EventEmitter<any>();
    constructor( public eRef : ElementRef,public layoutService: LayoutService, private cd: ChangeDetectorRef, public router: Router, private menuService: MenuService
        ,public menuSelectionService : MenuSelectionService
    ) {
        this.menuSourceSubscription = this.menuService.menuSource$.subscribe(value => {
            Promise.resolve(null).then(() => {
                if (value.routeEvent) {
                    this.active = (value.key === this.key || value.key.startsWith(this.key + '-')) ? true : false;
                }
                else {
                    if (value.key !== this.key && !value.key.startsWith(this.key + '-')) {
                        this.active = false;
                    }
                }
            });
        });

        this.menuResetSubscription = this.menuService.resetSource$.subscribe(() => {
            this.active = false;
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(params => {
                if (this.item.routerLink) {
                    this.updateActiveStateFromRoute();
                }
            });
    }

    ngOnInit() {
        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);

        if (this.item.routerLink) {
            this.updateActiveStateFromRoute();
        }
        if(!this.menuService.childItems.length)
        this.fillChildRow()
    }

    fillChildRow(){
     if(this.childItems.length==0){
        if(this.item && this.item.items && this.item.items.length){
            for(let i=0;i<this.item.items.length;i++){
                if(this.item.items[i] && this.item.items[i]?.items)
                this.childItems = [...this.childItems ,...this.item.items[i].items.map((x:any)=>x.label)]
            }
            this.menuService.childItems= this.childItems
        }
    }
    }

    updateActiveStateFromRoute() {
        let activeRoute = this.router.isActive(this.item.routerLink[0], { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' });

        if (activeRoute) {
            this.menuService.onMenuStateChange({ key: this.key, routeEvent: true });
        }
    }

    itemClick(event: Event) { 
        this.menuSelectionService.selectItem(this.item); 
        // avoid processing disabled items
        if (this.item.disabled) {
            event.preventDefault();
            return;
        }

        // execute command
        if (this.item.command) {
            this.item.command({ originalEvent: event, item: this.item });
        }

        // toggle active state
        if (this.item.items) {
            this.active = !this.active;
        }

        this.menuService.onMenuStateChange({ key: this.key });
    }

    get submenuAnimation() {
        return this.root ? 'expanded' : (this.active ? 'expanded' : 'collapsed');
    }

    @HostBinding('class.active-menuitem')
    get activeClass() {
        return this.active && !this.root;
    }

    ngOnDestroy() {
        if (this.menuSourceSubscription) {
            this.menuSourceSubscription.unsubscribe();
        }

        if (this.menuResetSubscription) {
            this.menuResetSubscription.unsubscribe();
        }
    }
}
